import dayjs from '~/timeInit';

import { DepartureInventory } from '~/types/tours/inventory';

/** Replay all movements through the end of a local calendar day. */
export function inventoryAtDate(
  inventory: DepartureInventory | undefined,
  date?: number,
): DepartureInventory | undefined {
  if (!inventory || date === undefined) return inventory;

  const cutoff = dayjs(date).endOf('day').valueOf();
  const entries = inventory.entries.filter((entry) => dayjs(entry.occurredAt).valueOf() <= cutoff);
  const counts = new Map<string, number>();
  let units = 0;
  entries.forEach((entry) => {
    const change = entry.operation === 'allocated' ? 1 : -1;
    units += change;
    counts.set(entry.packageConfigurationId, (counts.get(entry.packageConfigurationId) ?? 0) + change);
  });

  return {
    ...inventory,
    entries,
    units,
    configurations: inventory.configurations.map((configuration) => ({
      ...configuration,
      units: counts.get(configuration.packageConfigurationId) ?? 0,
    })),
  };
}
